export default "__VITE_ASSET__AlccXvL8__"